import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { Icon } from 'semantic-ui-react';

import Button from 'components/elements/buttons/Button';
import MobileAppLinkUrl
  from 'components/dashboard/mobile-app-links/MobileAppLinkUrl';
import MobileAppLinkText
  from 'components/dashboard/mobile-app-links/MobileAppLinkText';
import MobileAppLinkButtonTypeSelector
  from 'components/dashboard/mobile-app-links/MobileAppLinkButtonTypeSelector';
import MobileAppLinkThumbnail
  from 'components/dashboard/mobile-app-links/MobileAppLinkThumbnail';

import './MobileAppLinkEditForm.css';

const MobileAppLinkEditForm = props => {
  const { item, closeEditForm, mobile } = props;
  const { t } = useTranslation();

  return (
    <div className="mobile-app-link-edit-form__component">
      <div className="name-url">
        <MobileAppLinkUrl
          linkId={item.id}
          url={item.url}
          appType={item.app_type}
        />
        <MobileAppLinkText
          linkId={item.id}
          name={item.name}
        />
      </div>

      <div className="thumbnail-colors">
        <div className="thumbnail">
          <MobileAppLinkThumbnail
            linkId={item.id}
            thumbnail={item.thumbnail}
          />
        </div>
        <div className="colors">
          <MobileAppLinkButtonTypeSelector
            linkId={item.id}
            initialColor={item.button_color}
            key={`mobile-app-link-button-color-picker-key-${item.id}`}
            pickerId={`mobile-app-link-button-color-picker-id-${item.id}`}
            label={t("Button Color")}
            defaultColor="#616FB1"
            parameter='button_color'
          />
          <MobileAppLinkButtonTypeSelector
            linkId={item.id}
            initialColor={item.font_color}
            key={`mobile-app-link-font-color-picker-key-${item.id}`}
            pickerId={`mobile-app-link-font-color-picker-id-${item.id}`}
            label={t("Font Color")}
            defaultColor="#FFFFFF"
            parameter='font_color'
          />
        </div>
      </div>

      {!mobile &&
        <div className="buttons-block">
          <Button onClick={closeEditForm}>
            <Icon name="arrow left" />
            <div className="text">{t("Back")}</div>
          </Button>
        </div>
      }
    </div>
  );
};

MobileAppLinkEditForm.propTypes = {
  closeEditForm: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  mobile: PropTypes.bool,
};

MobileAppLinkEditForm.defaultProps = {
  mobile: null,
};

export default MobileAppLinkEditForm;
